module.exports = __webpack_public_path__ + "a5553fb0537126610afd63a7048e85cd.png";